const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144.63 22.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.59,8.36c.79-2.07.64-4.06-.42-5.6-1.21-1.75-3.49-2.76-6.25-2.76-5.48,0-7.98,3.58-7.98,6.91,0,2.5,1.51,3.83,2.32,4.54l1.24,1.16c.84.75,1.23,1.5,1.23,2.36,0,1.34-.9,2.69-2.92,2.69-1.06,0-1.89-.39-2.35-1.1-.53-.82-.52-2.01.03-3.26.06-.13.04-.27-.03-.39-.08-.12-.21-.19-.34-.19H.92c-.16,0-.31.1-.38.25-.87,2.01-.69,4.34.46,6.09,1.27,1.92,3.57,2.98,6.47,2.98,5.43,0,8.27-3.69,8.27-7.34,0-2.2-1.25-3.53-2.16-4.51,0,0-.08-.08-.08-.09l-1.2-1.15c-.77-.67-1.36-1.25-1.36-2.12,0-1.55,1.04-2.52,2.72-2.52.95,0,1.73.35,2.12.97.44.68.4,1.63-.12,2.74-.06.13-.05.28.03.39s.21.19.35.19h4.18c.17,0,.32-.1.38-.26Z",
    style: {
      fill: "#17172d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.47.74c-.06-.17-.21-.27-.39-.27h-5.66c-.09,0-.19.03-.26.09l-8.87,7.16-.21-6.85c0-.22-.19-.4-.41-.4h-4.09c-.11,0-.22.04-.3.13-.08.08-.12.19-.12.3l.37,11.77-5.04,8.31c-.08.13-.08.29,0,.41.07.13.21.21.36.21h4.41c.14,0,.28-.08.35-.2l5.07-8.35L44.34,1.19c.14-.11.19-.29.13-.46Z",
    style: {
      fill: "#17172d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,.67c-.07-.13-.21-.21-.36-.21h-4.38c-.14,0-.28.08-.35.2l-7.57,12.49.41-12.26c0-.11-.04-.22-.12-.3-.08-.08-.18-.13-.3-.13h-4.52c-.14,0-.28.08-.35.2l-12.24,20.3c-.08.13-.08.29,0,.42.07.13.21.21.36.21h4.35c.14,0,.28-.08.35-.2l7.59-12.46-.44,12.23c0,.11.04.22.11.3.08.08.18.13.3.13h4.52c.14,0,.28-.08.35-.2L63.99,1.09c.08-.13.08-.29,0-.42Z",
    style: {
      fill: "#17172d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.72,4.74c1.99,0,3.31,1.1,3.62,3.02.03.2.2.34.41.34h4.32c.12,0,.23-.05.31-.14.08-.09.11-.21.1-.32-.61-4.78-3.88-7.64-8.76-7.64-6.23,0-9.81,4.03-9.81,11.06s3.63,10.99,9.72,10.99c4.78,0,8.08-2.96,8.82-7.92.02-.12-.02-.24-.1-.33-.08-.09-.19-.14-.31-.14h-4.32c-.2,0-.38.15-.41.35-.32,2.1-1.66,3.3-3.68,3.3-2.99,0-4.58-2.17-4.58-6.29s1.53-6.29,4.66-6.29Z",
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.2.47h-4.18c-.23,0-.41.18-.41.41v7.3h-7.41V.88c0-.23-.18-.41-.41-.41h-4.18c-.23,0-.41.18-.41.41v20.3c0,.23.18.41.41.41h4.18c.23,0,.41-.18.41-.41v-8.26h7.41v8.26c0,.23.18.41.41.41h4.18c.23,0,.41-.18.41-.41V.88c0-.23-.18-.41-.41-.41Z",
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.99,13.52c3.03-.82,4.82-3.16,4.82-6.38,0-4.12-2.86-6.68-7.46-6.68h-9.13c-.23,0-.41.18-.41.41v20.3c0,.23.18.41.41.41h4.18c.23,0,.41-.18.41-.41v-7.48h1.23l5.5,7.72c.08.11.2.17.34.17h5.1c.15,0,.3-.09.37-.22.07-.14.06-.3-.03-.43l-5.32-7.41ZM110.81,5.2h4.52c.91,0,2.43.25,2.43,1.94s-1.52,1.94-2.43,1.94h-4.52v-3.87Z",
    style: {
      fill: "#5c5ab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.85,0c-6.03,0-9.78,4.22-9.78,11.02s3.75,11.02,9.78,11.02,9.78-4.22,9.78-11.02-3.75-11.02-9.78-11.02ZM134.85,17.31c-2.95,0-4.64-2.29-4.64-6.29s1.69-6.29,4.64-6.29,4.66,2.29,4.66,6.29-1.7,6.29-4.66,6.29Z",
    style: {
      fill: "#5c5ab3"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/LOGO1.669fd6799aae62af1164f6e84a1431eb.svg";
export { ForwardRef as ReactComponent };